import { render, staticRenderFns } from "./LoadingForum.vue?vue&type=template&id=302e029e&scoped=true&"
import script from "./LoadingForum.vue?vue&type=script&lang=js&"
export * from "./LoadingForum.vue?vue&type=script&lang=js&"
import style0 from "./LoadingForum.vue?vue&type=style&index=0&id=302e029e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "302e029e",
  null
  
)

export default component.exports